import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IItineary } from "../itinearyModel";

export const getAllItinerary = createAsyncThunk(
  "Itinerary/FindAllItinerary",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Itinerary/FindAllItinerary`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createItinerary = createAsyncThunk(
  "Itinerary/InsertItinerary",
  async (ItineraryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Itinerary/InsertItinerary`,
        ItineraryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateItinerary = createAsyncThunk(
  "Itinerary/UpdateItinerary",
  async (ItineraryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Itinerary/UpdateItinerary`,
        ItineraryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteItinerary = createAsyncThunk(
  "Itinerary/DeleteItinerary",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Itinerary/DeleteItinerary`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Itinerary", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getItineraryByID = createAsyncThunk(
  "Itinerary/FindByIDItinerary",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Itinerary/FindByIDItinerary?ID=${ID}`
      );

      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        CityID: result?.CityID,
        ItineraryTitle: result?.ItineraryTitle,
        Description: result?.Description,
        ItineraryImage: result?.ItineraryImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IItineary;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveItinerary = createAsyncThunk(
  "Itinerary/FindAllActiveItinerary",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Itinerary/FindAllActiveItinerary`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching  Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveItinerary = createAsyncThunk(
  "Itinerary/ActiveInActiveItinerary",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Itinerary/ActiveInActiveItinerary`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Itinerary", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
